import { createStore } from '@reduxjs/toolkit'
import { composeWithDevTools } from '@redux-devtools/extension'
import { reducer } from './reducers'
import { persistStore, persistReducer } from 'redux-persist'
import sessionStorage from 'redux-persist/es/storage/session'

const persistConfig = {
  key: 'root',
  storage: sessionStorage,
}

const persistedReducer = persistReducer(persistConfig, reducer)


export const store = createStore(persistedReducer, composeWithDevTools())
export const persistor = persistStore(store)